import React, { useEffect } from "react";
import { useState } from "react";
import { Image } from "antd";
import "./Gallery.css";
import Imagegallery from "../Data/Imagegallery";
import banner from '../Images/twentythreea.jpg'
import Footer from "../Component/Footer/Footer";
import { MetaTags } from "react-meta-tags";
import { Zoom } from "react-awesome-reveal";


const Gallery = () => {
  const [category, setCategory] = useState("all");
 useEffect(()=>{
        window.scrollTo(0, 0);
    },[])
  return (
    <>
    <MetaTags>
                            <title>Family Resort In Neral | Seema Resort</title>
                            <meta title="Family Resort In Neral | Seema Resort" />
                            <meta name="description" content="Seema Resort, the ideal Family Resort in Neral, offers a serene getaway with comfortable stays, delicious cuisine, and fun activities." />
                            <meta name="keywords" content="Best Resort in Mahabaleshwar, Top Resort with Rooms in Mahabaleshwar, Resort with Valley View in Mahabaleshwar, Resort with Premium Rooms in Mahabaleshwar, Best 3BHK Villa in Mahabaleshwar, Premium Villa in Mahabaleshwar, Family Resort in Mahabaleshwar, Resort near Mahabaleshwar" />
                            <link rel="canonical" href="https://seemasresort.com/family-resort-neral" />
                            <meta http-equiv="cache-control" content="no-cache" />
                            <meta http-equiv="expires" content="0" />
                            <meta http-equiv="pragma" content="no-cache" />
                            <meta property="og:title" content=" Family Resort In Neral | Seema Resort" />
                            <meta property="og:locale" content="en_US" />
                            <meta property="og:type" content="website" />
                            <meta property="og:url" content="https://seemasresort.com/" />
                            <meta property="og:description" content="Seema Resort, the ideal Family Resort in Neral, offers a serene getaway with comfortable stays, delicious cuisine, and fun activities." />
                            <meta property="og:image" content="https://seemasresort.com/static/media/logo.png" />
                          </MetaTags>
    <section className=' About-Page-Section-Banner-Images'  style={{
    backgroundImage:`linear-gradient(90deg, rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)), url(${banner})`
    ,backgroundSize:'cover',
    // height:'350px',objectFit:'cover'
    }}>
        <div className='About-Page-Section-Banner-Images-con'>
          <h2 className='mt-5 ms-5' style={{color:'white'}}>Gallery</h2>
        </div>
      </section>
      <div className="container mt-4 my-2 ">
<h1 className="text-start heading" style={{fontFamily:" var(---lato)"}}>Family Resort In Neral  </h1>
</div>
      <div className="container mt-5">
        <h5 className="tex-center">
          <div className="gallerybtndiv" >
            <div >
            <button
              onClick={() => {
                setCategory("all");
              }}
              className={`px-4 ${category==='all'?'activetab':'gallerybtn'} `}
            >
              All
            </button>
            
            <button
              onClick={() => {
                setCategory("event");

              }}
              className={`px-3 ${category==='event'?'activetab':'gallerybtn'}`}
            >
              Events
            </button>
            
            <button
              onClick={() => {
                setCategory("room");
              }}
              className={`px-3 ${category==='room'?'activetab':'gallerybtn'}`}
            >
              Rooms
            </button>
            </div>
          </div>
        </h5>

        <div className="row mt-5 mb-5" style={{ backgroundColor: "white" }}>
          <Image.PreviewGroup>
            {Imagegallery.filter((data) =>
              category !== "all" ? data.category === category : data
            ).map((Imagedata, i) => (
              <div
                className="col-12 col-md-6 col-lg-4 col-xlg-4 col-xxlg-4 p-2"
                style={{ margin: "auto" }}
              >
               <Zoom direction="out">
                  <Image
                    src={Imagedata.img}
                    id="imagesub"
                    className="img-fluid "
                    style={{
                      height: "300px",
                      width: "100%",
                      borderRadius: "10px",
                    }}
                  />
                  </Zoom>
                  
                
              </div>
            ))}
          </Image.PreviewGroup>
        </div>
      </div>
      <div className="container my-5" style={{display:'none'}}>
        <p className="lead">
        Welcome to the Seema Resort Gallery, where moments come alive through stunning visuals. Nestled amidst nature's beauty, our Family Resort in Neral offers an idyllic escape filled with relaxation, joy, and unforgettable memories. Explore our gallery to get a glimpse of the lush landscapes, modern amenities, and wonderful experiences that await you.

        </p>
        <p className="lead">
        Our photo collection showcases the serene beauty of our surroundings, from tranquil gardens to beautifully designed accommodations. Whether you’re looking for a weekend retreat or a fun family getaway, our Family Resort in Neral has something for everyone. Browse through images of our spacious rooms, outdoor lawns, and recreational areas to see why guests love coming here.

        </p>
        <p className="lead">
        In the gallery, you’ll find pictures of our vibrant events and celebrations. From birthday parties and weddings to corporate gatherings, Seema Resort is the perfect venue for creating lifelong memories. As a Family Resort in Neral, we pride ourselves on providing spaces that cater to both adults and children, ensuring a fun-filled experience for the whole family.

        </p>
        <p className="lead">
        Take a virtual tour of our sparkling swimming pool, where guests enjoy a refreshing dip, and check out our cosy indoor spaces that offer comfort and style. Our dining areas, with delectable cuisines, are also highlighted in our gallery, capturing the delightful culinary experiences our resort offers.

        </p>
        <p className="lead">
        We believe that pictures speak louder than words. Let our gallery inspire you to book your next vacation or special event with us. At Seema Resort, every corner offers a perfect photo opportunity, making your stay truly special.

          </p>
          <p className="lead">
          Browse our gallery today and discover why Seema Resort is the go-to Family Resort in Neral for relaxation, adventure, and celebration.

          </p>
         
      </div>
      <Footer/>
    </>
  );
};

export default Gallery;
